<div class="pm-overlay" *ngIf="prospect" (click)="close()">
    <div class="pm-modal" (click)="$event.stopPropagation(); closeMenu()">
        <button type="button" class="pm-close" (click)="close()"><i class="fa-solid fa-xmark"></i></button>

        <!-- Hamburger menu -->
        <div class="pm-menu-wrap">
            <button type="button" class="pm-menu-btn" (click)="toggleMenu(); $event.stopPropagation()"><i class="fa-solid fa-ellipsis-vertical"></i></button>
            <div class="pm-menu-dropdown" *ngIf="menuOpen" (click)="$event.stopPropagation()">
                <button (click)="startEdit(); closeMenu()"><i class="fa-solid fa-pen"></i> Edit Company</button>
                <button *ngIf="(prospect.domain || prospect.website) && !prospect.hunterEnriched" [disabled]="enriching" (click)="enrich(true); closeMenu()">
                    <i class="fa-solid fa-wand-magic-sparkles"></i> Enrich with Hunter
                </button>
                <button (click)="toggleNewContact(); closeMenu(); setTab('contacts')"><i class="fa-solid fa-user-plus"></i> Add Contact</button>
                <button (click)="setTab('timeline'); closeMenu()"><i class="fa-solid fa-clock-rotate-left"></i> View Timeline</button>
            </div>
        </div>

        <!-- LinkedIn-style company header -->
        <div class="pm-banner"></div>
        <div class="pm-header">
            <div class="pm-logo" [class.is-placeholder]="!prospect.logoUrl">
                <img *ngIf="prospect.logoUrl" [src]="prospect.logoUrl" (error)="prospect.logoUrl = ''" />
                <span *ngIf="!prospect.logoUrl">{{ prospect.name.charAt(0) | uppercase }}</span>
            </div>

            <div class="pm-header-main">
                <div class="pm-name-row">
                    <h2>{{ prospect.name }}</h2>
                    <span class="pm-industry-badge" *ngIf="prospect.industry">{{ prospect.industry }}</span>
                </div>
                <div class="pm-header-sub" *ngIf="prospect.domain">
                    <i class="fa-solid fa-globe"></i>
                    <a [href]="prospect.website" target="_blank">{{ prospect.domain }}</a>
                </div>
                <div class="pm-meta">
                    <span class="pm-meta-item" *ngIf="prospect.city || prospect.country"><i class="fa-solid fa-location-dot"></i>{{ prospect.city }}<span *ngIf="prospect.city && prospect.country">, </span>{{ prospect.country }}</span>
                    <span class="pm-meta-item" *ngIf="prospect.headcount"><i class="fa-solid fa-users"></i>{{ prospect.headcount }} employees</span>
                    <span class="pm-meta-item" *ngIf="prospect.foundedYear"><i class="fa-solid fa-calendar"></i>Founded {{ prospect.foundedYear }}</span>
                    <span class="pm-meta-item" *ngIf="prospect.rating"><i class="fa-solid fa-star"></i>{{ prospect.rating }} ({{ prospect.reviewCount || 0 }})</span>
                </div>
            </div>

            <div class="pm-status">
                <span class="pm-status-dot" [style.background-color]="statusColor(prospect.status)"></span>
                <select [ngModel]="prospect.status" (ngModelChange)="changeStatus($event)">
                    <option *ngFor="let s of statusOptions" [value]="s">{{ statusLabels[s] }}</option>
                </select>
            </div>
        </div>

        <!-- Social bar -->
        <div class="pm-socialbar" *ngIf="prospect.linkedInUrl || prospect.twitterUrl || prospect.facebookUrl || prospect.instagramUrl || prospect.youtubeUrl || prospect.googleMapsUrl">
            <a *ngIf="prospect.linkedInUrl" [href]="prospect.linkedInUrl" target="_blank" title="LinkedIn"><i class="fa-brands fa-linkedin"></i> LinkedIn</a>
            <a *ngIf="prospect.twitterUrl" [href]="prospect.twitterUrl" target="_blank" title="Twitter / X"><i class="fa-brands fa-x-twitter"></i> X</a>
            <a *ngIf="prospect.facebookUrl" [href]="prospect.facebookUrl" target="_blank" title="Facebook"><i class="fa-brands fa-facebook"></i> Facebook</a>
            <a *ngIf="prospect.instagramUrl" [href]="prospect.instagramUrl" target="_blank" title="Instagram"><i class="fa-brands fa-instagram"></i> Instagram</a>
            <a *ngIf="prospect.youtubeUrl" [href]="prospect.youtubeUrl" target="_blank" title="YouTube"><i class="fa-brands fa-youtube"></i> YouTube</a>
            <a *ngIf="prospect.googleMapsUrl" [href]="prospect.googleMapsUrl" target="_blank" title="Google Maps"><i class="fa-solid fa-map"></i> Maps</a>
        </div>

        <div class="pm-alert" *ngIf="error">{{ error }}</div>

        <!-- Enriching indicator -->
        <div class="pm-enriching" *ngIf="enriching">
            <i class="fa-solid fa-spinner fa-spin"></i> Enriching with Hunter.io...
        </div>

        <!-- Assignment -->
        <div class="pm-assign-row">
            <span class="pm-assign-label"><i class="fa-solid fa-user-tag"></i> Assigned:</span>
            <select [ngModel]="prospect.assignedToUid || ''" (ngModelChange)="assignTo($event || null)">
                <option value="">Unassigned</option>
                <option *ngFor="let a of assignees" [value]="a.$key">{{ a.displayName }}</option>
            </select>
            <select [ngModel]="prospect.prospectType || ''" (ngModelChange)="changeProspectType($event)">
                <option value="">No type</option>
                <option *ngFor="let t of prospectTypeOptions" [value]="t">{{ prospectTypeLabels[t] }}</option>
            </select>
            <span class="pm-source-badge" *ngIf="prospect.source">{{ sourceLabels[prospect.source] || prospect.source }}</span>
            <span class="pm-hunter-pill" *ngIf="prospect.hunterEnriched"><i class="fa-solid fa-circle-check"></i> Hunter</span>
        </div>

        <!-- Tabs -->
        <div class="pm-tabs">
            <button type="button" [class.active]="activeTab === 'overview'" (click)="setTab('overview')">
                <i class="fa-solid fa-circle-info"></i> Overview
            </button>
            <button type="button" [class.active]="activeTab === 'contacts'" (click)="setTab('contacts')">
                <i class="fa-solid fa-address-book"></i> People ({{ contacts.length }})
            </button>
            <button type="button" [class.active]="activeTab === 'timeline'" (click)="setTab('timeline')">
                <i class="fa-solid fa-clock-rotate-left"></i> Timeline ({{ interactions.length }})
            </button>
            <button type="button" [class.active]="activeTab === 'comments'" (click)="setTab('comments')">
                <i class="fa-solid fa-comments"></i> Comments ({{ comments.length }})
            </button>
        </div>

        <div class="pm-body">
            <!-- Overview tab -->
            <div *ngIf="activeTab === 'overview'" class="pm-overview">
                <ng-container *ngIf="!editing">
                    <p class="pm-description" *ngIf="prospect.description">{{ prospect.description }}</p>
                    <div class="pm-info" *ngIf="prospect.fullAddress"><i class="fa-solid fa-location-dot"></i><span>{{ prospect.fullAddress }}</span></div>
                    <div class="pm-info" *ngIf="prospect.phone"><i class="fa-solid fa-phone"></i><span>{{ prospect.phone }}</span></div>
                    <div class="pm-info" *ngIf="prospect.companyType"><i class="fa-solid fa-building"></i><span>{{ prospect.companyType }}</span></div>
                    <div class="pm-info" *ngIf="prospect.notes"><i class="fa-solid fa-sticky-note"></i><span>{{ prospect.notes }}</span></div>

                    <div class="pm-tech" *ngIf="prospect.technologies?.length">
                        <h3>Technologies</h3>
                        <span class="pm-tech-chip" *ngFor="let t of prospect.technologies">{{ t }}</span>
                    </div>

                    <h3 *ngIf="prospect.nearestParkings?.length">Nearest parkings</h3>
                    <div class="pm-nearest" *ngFor="let n of prospect.nearestParkings">
                        <i class="fa-solid fa-square-parking"></i>
                        <span>{{ n.parkingName }}</span>
                        <strong>{{ n.distanceKm }} km</strong>
                    </div>

                    <div class="pm-enrich-note" *ngIf="!prospect.domain && !prospect.website">
                        <i class="fa-solid fa-circle-info"></i>
                        No website/domain — use the menu to edit and add a website for Hunter enrichment.
                    </div>
                </ng-container>

                <ng-container *ngIf="editing">
                    <div class="pm-edit-form">
                        <label class="pm-field-label">Name</label>
                        <input type="text" [(ngModel)]="editData.name" />
                        <label class="pm-field-label">Address</label>
                        <input type="text" [(ngModel)]="editData.fullAddress" />
                        <label class="pm-field-label">Website</label>
                        <input type="text" [(ngModel)]="editData.website" />
                        <label class="pm-field-label">Phone</label>
                        <input type="text" [(ngModel)]="editData.phone" />
                        <label class="pm-field-label">LinkedIn URL</label>
                        <input type="text" [(ngModel)]="editData.linkedInUrl" />
                        <label class="pm-field-label">Notes</label>
                        <textarea [(ngModel)]="editData.notes" rows="3"></textarea>
                        <div class="pm-btn-row">
                            <button type="button" class="pm-enrich" (click)="saveEdit()"><i class="fa-solid fa-check"></i> Save</button>
                            <button type="button" class="pm-edit-btn" (click)="cancelEdit()">Cancel</button>
                        </div>
                    </div>
                </ng-container>
            </div>

            <!-- People tab -->
            <div *ngIf="activeTab === 'contacts'" class="pm-contacts">
                <button type="button" class="pm-add-contact-btn" (click)="toggleNewContact()">
                    <i class="fa-solid" [class.fa-plus]="!showNewContact" [class.fa-xmark]="showNewContact"></i>
                    {{ showNewContact ? 'Cancel' : 'New Contact' }}
                </button>

                <div class="pm-new-contact-form" *ngIf="showNewContact">
                    <input type="text" placeholder="Full Name" [(ngModel)]="newContact.fullName" />
                    <input type="email" placeholder="Email" [(ngModel)]="newContact.email" />
                    <input type="text" placeholder="Position" [(ngModel)]="newContact.position" />
                    <input type="text" placeholder="Phone" [(ngModel)]="newContact.phone" />
                    <input type="text" placeholder="LinkedIn URL" [(ngModel)]="newContact.linkedInUrl" />
                    <button type="button" class="pm-enrich" [disabled]="addingContact" (click)="saveNewContact()">
                        <i class="fa-solid" [class.fa-spinner]="addingContact" [class.fa-spin]="addingContact" [class.fa-check]="!addingContact"></i>
                        Save Contact
                    </button>
                </div>

                <div class="pm-empty" *ngIf="!contacts.length && !showNewContact">No people yet. Add manually or use the menu to enrich.</div>

                <div class="pm-person" *ngFor="let c of contacts" (click)="openContact(c)">
                    <div class="pm-person-avatar" [class.is-placeholder]="!contactAvatar(c)">
                        <img *ngIf="contactAvatar(c)" [src]="contactAvatar(c)" [alt]="contactName(c)" />
                        <span *ngIf="!contactAvatar(c)">{{ contactInitials(c) }}</span>
                    </div>
                    <div class="pm-person-main">
                        <div class="pm-person-name">
                            {{ contactName(c) }}
                            <span class="pm-primary-badge" *ngIf="c.isPrimary"><i class="fa-solid fa-star"></i> Primary</span>
                        </div>
                        <div class="pm-person-pos" *ngIf="c.position">{{ c.position }}<span *ngIf="c.seniority"> &middot; {{ c.seniority }}</span></div>
                        <div class="pm-person-email" *ngIf="c.email">{{ c.email }}</div>
                        <div class="pm-person-activity" *ngIf="contactInteractionCount(c.$key)">
                            <i class="fa-solid fa-clock-rotate-left"></i>
                            {{ contactInteractionCount(c.$key) }} interaction(s)
                            <span *ngIf="contactLastInteraction(c.$key) as last"> &middot; last: {{ interactionTypeLabels[last.type] }}</span>
                        </div>
                    </div>
                    <div class="pm-person-actions" (click)="$event.stopPropagation()">
                        <button type="button" class="pm-star-btn" [class.pm-star-active]="c.isPrimary" (click)="togglePrimary(c)" title="Toggle primary contact"><i class="fa-solid fa-star"></i></button>
                        <button type="button" class="pm-view" (click)="openContact(c)" title="Open profile"><i class="fa-solid fa-arrow-right"></i></button>
                    </div>
                </div>
            </div>

            <!-- Timeline tab -->
            <div *ngIf="activeTab === 'timeline'" class="pm-timeline">
                <div class="pm-log-form">
                    <select [(ngModel)]="newInteraction.type">
                        <option *ngFor="let t of interactionTypes" [value]="t">{{ interactionTypeLabels[t] }}</option>
                    </select>
                    <input type="text" placeholder="What happened?" [(ngModel)]="newInteraction.summary" (keyup.enter)="logInteraction()" />
                    <button type="button" [disabled]="addingInteraction || !newInteraction.summary.trim()" (click)="logInteraction()">
                        <i class="fa-solid" [class.fa-spinner]="addingInteraction" [class.fa-spin]="addingInteraction" [class.fa-plus]="!addingInteraction"></i>
                        Log
                    </button>
                </div>

                <div class="pm-empty" *ngIf="!interactions.length">No interactions logged yet.</div>

                <div class="pm-interaction" *ngFor="let i of interactions">
                    <div class="pm-interaction-icon"><i [class]="interactionTypeIcons[i.type] || 'fas fa-comment'"></i></div>
                    <div class="pm-interaction-body">
                        <div class="pm-interaction-head">
                            <strong>{{ interactionTypeLabels[i.type] || i.type }}</strong>
                            <span *ngIf="i.denormContactName"> &middot; {{ i.denormContactName }}</span>
                            <span class="pm-interaction-date">{{ interactionDate(i) | date: 'short' }}</span>
                        </div>
                        <div class="pm-interaction-summary">{{ i.summary }}</div>
                        <div class="pm-interaction-email" *ngIf="i.emailSubject">Subject: {{ i.emailSubject }}</div>
                        <div class="pm-interaction-meta" *ngIf="i.denormCreatedByName">By {{ i.denormCreatedByName }}</div>
                    </div>
                </div>
            </div>

            <!-- Comments tab -->
            <div *ngIf="activeTab === 'comments'" class="pm-comments">
                <div class="pm-add-comment">
                    <textarea [(ngModel)]="newComment" rows="2" placeholder="Add an internal note..."></textarea>
                    <button type="button" [disabled]="addingComment || !newComment.trim()" (click)="addComment()">
                        <i class="fa-solid" [class.fa-spinner]="addingComment" [class.fa-spin]="addingComment" [class.fa-paper-plane]="!addingComment"></i>
                        Post
                    </button>
                </div>

                <div class="pm-empty" *ngIf="!comments.length">No comments yet.</div>

                <div class="pm-comment" *ngFor="let cm of comments">
                    <div class="pm-comment-head">
                        <strong>{{ cm.createdByName }}</strong>
                        <span class="pm-comment-date" *ngIf="cm.createdAt">{{ cm.createdAt.toDate() | date: 'short' }}</span>
                    </div>
                    <div class="pm-comment-text">{{ cm.text }}</div>
                </div>
            </div>
        </div>
    </div>
</div>
